import React from 'react';
import '../../resource/css/commons/modal.css'
import close from '../../resource/img/modal/circleclose.svg';
import person from '../../resource/img/modal/modalperson.svg';

const Modal = ({children, pasoActual}) => 
(  
    <> 
        <div id="modal1" className="modal container-modal">
            <a className="modal-content-close d-flex justify-content-end" href="#"><img src={close} alt=""/></a>
            <div className="modal-content container-modal-content d-flex flex-column align-items-center">
                <a><img src={person} alt=""/></a>
                <h1>Este cliente <b>no tiene métodos de pago</b> registrados en nuestro sistema.</h1>
            </div>
            <div className="modal-footer container-modal-footer d-flex flex-column align-items-center">
            <a href="#!" className="btn-rimac modal-close waves-effect waves-light btn-flat">DE ACUERDO</a>
            </div>
        </div>
    </>
)


export default Modal;